// extracted by mini-css-extract-plugin
export default {"primary-color":"#006266","secondaryColor":"#ff8945","step":"tutorial-step_step__fX+rl"};